import { useTranslation } from "next-i18next";
import React from "react";

import { Button } from "components/ui/Button";
import { IListingLookupDto } from "common/middleware/api.services";

interface Props {
  properties: IListingLookupDto[]
}

export function UnitNav({ properties }: Props) {
  const { t } = useTranslation("checkout");
  const unitList = properties.map((unit) => {
    return (
      <tr key={unit.id} data-cy="property">
        <td>{unit.unitNumber}</td>
        <td>{unit.name}</td>
        <td>{unit.state}</td>
        <td>{unit.bedroomQuantity}</td>
        <td>
          {unit.bathroomQuantity} / {unit.powderRoomQuantity}{" "}
        </td>
        <td data-cy="select">
          <Button.Small href={t("/checkout/customization") + `?unit=${unit.id}`}>
            Select
          </Button.Small>
        </td>
        <td style={{ paddingLeft: 12 }}>
          <Button.Small
            href={`${process.env.NEXT_PUBLIC_AUTH_URL}/login?action=share&propertyId=${unit.id}`}
          >
            Share
          </Button.Small>
        </td>
      </tr>
    );
  });

  return (
    <div className="UnitNav">
      <table>
        <thead>
          <tr>
            <th>
              <b>Unit No</b>
            </th>
            <th>
              <b>Name</b>
            </th>
            <th>
              <b>Availability</b>
            </th>
            <th>
              <b>Bedrooms</b>
            </th>
            <th>
              <b>Bathrooms</b>
            </th>

            <th></th>
          </tr>
        </thead>
        <tbody>{unitList}</tbody>
      </table>
    </div>
  );
}
